import { BaseEnum } from './BaseEnum';

export const ErrorSeverity = {
    CRITICAL: 0,
    ERROR: 1,
    WARNING: 2,
    INFO: 3,
    NONE: 4,

    descriptions: {
        'Critical': 0,
        'Error': 1,
        'Warning': 2,
        'Info': 3,
        'None': 4,
    },

    ...BaseEnum,
};